import { render, staticRenderFns } from "./ycygVariation.vue?vue&type=template&id=22146868&scoped=true"
import script from "./ycygVariation.vue?vue&type=script&lang=js"
export * from "./ycygVariation.vue?vue&type=script&lang=js"
import style0 from "./ycygVariation.vue?vue&type=style&index=0&id=22146868&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22146868",
  null
  
)

export default component.exports